import React from 'react';

export default function Backdrop({ BackdropStatus, onBackDropClick, backdropPayload }) {
  return (
    <div
      className={BackdropStatus ? 'backdrop' : 'hide'}
      onClick={() => {
        onBackDropClick(backdropPayload);
      }}
    ></div>
  );
}
